import React, { useEffect, useState } from "react";
import axios from "axios";
import { Container, Typography, Box, useTheme, useMediaQuery } from "@mui/material";

function ApplicationMiddleware() {
    const [application, setApplication] = useState([]);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    useEffect(() => {
        axios
            .get("/files/solutions/application_middleware.txt")
            .then((res) => setApplication(res.data))
            .catch((err) => console.error(err));
    }, []);

    return (
        <Box sx={{ minHeight: "100vh", py: 2 }}>
            <Container maxWidth="lg">
                <Typography
                    align="center"
                    gutterBottom
                    sx={{
                        fontWeight: "bold",
                        color: "#030366",
                        mb: { xs: 4, sm: 5, md: 6 },
                        mt: 7,
                        fontSize: {
                            xs: "1.8rem", // mobile
                            sm: "2.2rem", // tablet
                            md: "2.8rem", // laptop
                            lg: "3rem",  // desktop
                        },
                    }}
                >
                    Application Middleware Management
                </Typography>

                <Box sx={{ color: "black", lineHeight: 1.6 }}>
                    {application &&
                        application.map((item, index) => (
                            <Box key={index} sx={{ mb: 2 }}>
                                {typeof item === "string" ? (
                                    <Typography variant="body1" sx={{ fontFamily: "Raleway, sans-serif" }}>
                                        {item}
                                    </Typography>
                                ) : (
                                    Object.entries(item).map(([title, content], idx) => (
                                        <Box key={idx} sx={{ mb: 1 }}>
                                            <Typography variant="h6" sx={{ fontWeight: "bold", color: "#030366" }}>
                                                {title}
                                            </Typography>
                                            {content.map((point, i) => (
                                                <Typography
                                                    key={i}
                                                    variant="body1"
                                                    sx={{ fontFamily: "Raleway, sans-serif", ml: 2 }}
                                                >
                                                    • {point}
                                                </Typography>
                                            ))}
                                        </Box>
                                    ))
                                )}
                            </Box>
                        ))}
                </Box>
            </Container>
        </Box>
    );
}

export default ApplicationMiddleware;
